import getConfig from 'next/config';
import { useEffect } from 'react';

/**
 * This extremely ugly inlined code is part of the script tag provided by Affirm to load their SDK
 *
 * Because we require a nonce for CSP, it's causing us a lot of trouble trying to selectively loading only
 * on checkout between serverside renders and client renders. This is a workaround.
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
export const Affirm = () => {
  const { publicRuntimeConfig } = getConfig();
  const {
    AFFIRM_SCRIPT_URL,
    AFFIRM_PUBLIC_KEY,
  }: { AFFIRM_SCRIPT_URL: string; AFFIRM_PUBLIC_KEY: string } = publicRuntimeConfig;

  useEffect(() => {
    // @ts-ignore
    window._affirm_config = {
      public_api_key: AFFIRM_PUBLIC_KEY,
      script: AFFIRM_SCRIPT_URL,
    };
    (function (l, g, m, e, a, f, b) {
      let d;
      const c = l[m] || {};
      const h = document.createElement(f);
      const n = document.getElementsByTagName(f)[0];
      const k = function (a, b, c) {
        return function () {
          a[b]._.push([c, arguments]);
        };
      };
      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);
      // @ts-ignore
      a = 0;
      for (
        // @ts-ignore
        b = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');
        // @ts-ignore
        a < b.length;
        // @ts-ignore
        a++
      )
        d[b[a]] = k(c, e, b[a]);
        // @ts-ignore
      a = 0;
      // @ts-ignore
      for (b = ['get', 'token', 'url', 'items']; a < b.length; a++) d[b[a]] = function () {};
      // @ts-ignore
      h.async = !0;
      // @ts-ignore
      h.src = g[f];
      n.parentNode.insertBefore(h, n);
      delete g[f];
      d(g);
      l[m] = c;
      // @ts-ignore
    })(window, _affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');
  });

  return null;
};
